import { useHospitalData } from "@/contexts/HospitalDataProvider";

/**
 * Whether the chosen department gets the report — the one gate the page AND its admin-menu entry read, so the real
 * endpoint opens both by changing this alone. Its own module so the always-loaded menu doesn't pull in the page's data
 * code. Today: demo departments only.
 */
export const useFillShiftReportAvailable = (): boolean => {
	const { isRealDemo } = useHospitalData();
	return isRealDemo;
};
